import React from "react";
import s from "./Button.module.scss";
import { BUTTONTYPES } from "../../constants/GeneralConstants";

export const Button = ({
  text,
  type,
  onClick,
  buttonColor,
  fontSize,
  width,
}) => {
  const buttoStyle = {
    color: buttonColor,
    backgroundColor: buttonColor,
    border: `1px solid ${buttonColor}`,
  };

  if (fontSize) {
    buttoStyle.fontSize = fontSize;
  }

  if (width) {
    buttoStyle.width = width;
  }

  return (
    <button
      className={type === BUTTONTYPES.primary ? s.primary : s.secondary}
      style={buttoStyle}
      onClick={onClick}
    >
      {text}
    </button>
  );
};
